import { LabelContainer } from "../assets/style";
import { Box, FormControl, MenuItem, Select } from "@mui/material";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

export default function HookSearchDropDownList<T extends FieldValues>(props: { title?: any, name: Path<T>, control: Control<T>, items: Array<{ id: any, name: string }>, addEmpty?: boolean }) {
    const { title, name, control, items, addEmpty } = props

    const containerStyle = {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
        minWidth: "200px",
        maxWidth: "400px",
    };
    const inputStyle = {
        margin: "10px",
        marginLeft: "28px",
        borderRadius: "6px",
        height: "32px",
        minWidth: "170px",
        maxWidth: "400px",
    };

    return (
        <Box sx={containerStyle}>
            {title && <LabelContainer style={{ marginLeft: "20px" }}>{title + ":"} </LabelContainer>}
            <FormControl sx={inputStyle}>
                <Controller
                    name={name}
                    control={control}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Select
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            displayEmpty={addEmpty}
                            style={{ marginBottom: "20px", backgroundColor: "white", height: "32px" }}
                        >
                            {addEmpty &&
                                <MenuItem>
                                    &nbsp;
                                </MenuItem>
                            }
                            {items?.map((item, index) => (
                                <MenuItem key={index} value={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                />
            </FormControl>
        </Box>

    );
}
